import { useTeam } from '../contexts/TeamContext';
import { Link } from 'react-router-dom';

export default function LicenseExpiredBanner() {
	const { currentTeam } = useTeam();

	// Only show if license is expired
	if (!currentTeam || currentTeam.license.type !== 'expired') {
		return null;
	}

	const isOwner = currentTeam.role === 'owner';

	return (
		<div className="bg-red-600 dark:bg-red-700 border-b border-red-700 dark:border-red-800">
			<div className="px-6 py-4">
				<div className="flex items-center justify-between">
					<div className="flex items-center space-x-3">
						<div className="flex-shrink-0">
							<svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
							</svg>
						</div>
						<div className="flex-1">
							<p className="text-sm font-semibold text-white">
								{isOwner ? 'Your license has expired' : 'Team license has expired'}
							</p>
							<p className="text-xs text-red-100 mt-0.5">
								{isOwner
									? 'Upgrade your license to continue using Clawdgate with full features.'
									: 'Please contact your team owner to renew the license.'
								}
							</p>
						</div>
					</div>
					{isOwner && (
						<Link
							to="/billing"
							className="flex-shrink-0 px-4 py-2 bg-white hover:bg-red-50 text-red-700 rounded-lg font-semibold text-sm transition-colors shadow-sm cursor-pointer"
						>
							Upgrade Now
						</Link>
					)}
				</div>
			</div>
		</div>
	);
}
